declare var AWS: any;

export class UserPost {
    //this is NOT the same as user sub, it is identity sub for IAM
     
    private sub: string = null;
    public postDate:string = new Date().toISOString();
    public postTimeStamp = new Date().valueOf();
    public UserPostId: string; 
    public votes:number = 0;
    public message:string = "";
    public picURL:string;
    public avatarURL:string;
    public avatarKey:string;
    public picKey:string;
    public userName:string
    public winRank:number = 0;
    public comments:number = 0;

    constructor(public category:string = null)
    {
        //if(this.UserPostId == null){
        //    this.UserPostId = this.guid();
        //}
        //this.sub = AWS.config.credentials.identityId;
    }

    public generateTestPost(){
        this.message = "This is a test message "+ new Date().toLocaleTimeString();
        this.picURL = "http://www.dogbreedslist.info/uploads/allimg/dog-pictures/Basset-Hound-2.jpg";
        this.votes = this.getRandomInt(0,10000);
    }

     guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
          s4() + '-' + s4() + s4() + s4();
      }
    
    private getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
      }
  }




// WEBPACK FOOTER //
// ./src/providers/user-posts.ts